import { render, staticRenderFns } from "./KullaniciIzinleriMatris.vue?vue&type=template&id=3ae8c62a&scoped=true"
import script from "./KullaniciIzinleriMatris.vue?vue&type=script&lang=ts"
export * from "./KullaniciIzinleriMatris.vue?vue&type=script&lang=ts"
import style0 from "./KullaniciIzinleriMatris.vue?vue&type=style&index=0&id=3ae8c62a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae8c62a",
  null
  
)

export default component.exports